/**
 * UranIA PA — `ruoloCorrente()`.
 *
 * L'unica funzione "da scrivere da zero" richiesta dal documento
 * "UranIA PA — Front end: pagina dei servizi e ambiente immersivo" §4.1:
 * ricava il `RuoloRealm` (vedi `lib/ruoli.ts`) dal principal OIDC già in
 * sessione, per i `beforeLoad` guard delle rotte `/servizi`, `/immersivo`
 * e per lo smistamento di `/`.
 *
 * Va letta con `useAuthStore.getState()` (non l'hook `useAuthStore(...)`):
 * `beforeLoad` gira fuori da un componente React, prima del render.
 *
 * Un principal può avere più ruoli realm contemporaneamente: l'ordine di
 * priorità sceglie l'atterraggio quando è ambiguo — chi ha anche un ruolo
 * admin atterra sempre sul cruscotto, mai sui servizi (documento 1 §1.1: "chi
 * ha entrambi i ruoli trova il collegamento nell'intestazione, non un
 * atterraggio ambiguo").
 */

import { useAuthStore } from './auth-store.ts';
import type { RuoloRealm } from '../ruoli.ts';

const ORDINE_PRIORITA: readonly RuoloRealm[] = [
  'platform_admin',
  'tenant_admin',
  'funzionario_adg',
  'beneficiario_ri',
];

export function ruoloCorrente(): RuoloRealm | null {
  const principal = useAuthStore.getState().principal;
  if (principal === null) {
    return null;
  }
  return ORDINE_PRIORITA.find((ruolo) => principal.roles.includes(ruolo)) ?? null;
}
